const t = {
  name: "Restricted",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 17H10V13C12.2077 13 14 14.7923 14 17H16C16 15.3341 15.3201 13.8262 14.2228 12.7387C15.2686 12.2691 16 11.2172 16 10C16 8.34772 14.6523 7 13 7H8V17ZM10 11V9H13C13.5477 9 14 9.45228 14 10C14 10.5477 13.5477 11 13 11H10Z" fill="currentColor"/>
<path d="M12 1C5.92772 1 1 5.92772 1 12C1 18.0723 5.92772 23 12 23C18.0723 23 23 18.0723 23 12C23 5.92772 18.0723 1 12 1ZM3 12C3 7.03228 7.03228 3 12 3C16.9677 3 21 7.03228 21 12C21 16.9677 16.9677 21 12 21C7.03228 21 3 16.9677 3 12Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Restricted
};
